module.exports = __webpack_public_path__ + "static/media/filter.67f0124f.svg";